import {useRef, useEffect} from 'react';

/**
 * Helper para evitar diversas requisições desnecessárias
 * @author Renan Salustiano <renansalustiano2020@gmail.com>
 * @param _function
 * @param delay
 */
const useDebounce = (_function, delay) => {

    if(typeof  _function != 'function'){
        return;
    }

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const timeoutRef = useRef(null);

    /**
     * Cancela timeout caso o componente seja desmontado
     */
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => () => clearTimeout(timeoutRef.current), []);

    const debouncedFunction = (...args) => {
        clearDebounce();
        timeoutRef.current = setTimeout(() => {
            _function(...args)
        }, delay)
    }

    const clearDebounce = () => {
        clearTimeout(timeoutRef.current);
    }

    return [debouncedFunction, clearDebounce]
}

export default useDebounce;
